import Vue from 'vue';
import popWinCtn from './popWinCtn.vue';

var router;

//使用Vue.use(popWin, router)来调用
export default {
    install(Vue, pageRouter) {
        router = pageRouter;
    }
}

//通过submit事件触发
//renderOpt参数类型 : {class,  style,  attrs,  domProps,  props,  on,  nativeOn,  directives,  scopedSlots,  slot,  key,  ref}
export function popComponent(popComp, renderOpt, childrenFn) {
    //点击返回按钮，需要关闭弹窗。外部可以用history.back()关闭弹框
    router.addRoutePar({ popup: '1' })
    var Dlg = Vue.extend({
        router,
        render(h) {
            return h(popComp, renderOpt, childrenFn && childrenFn(h))
        },
        watch: {
            '$route.query.popup'(popup) {
                if (!popup) {
                    instance.$el.remove()
                    instance.$destroy()
                }
            }
        }
    })
    var instance = new Dlg()
    document.body.appendChild(instance.$mount().$el)
}

//弹出一个全屏的窗口。winProps是窗口属性。popComp是一个vue组件示例，renderOpt是组件的属性
export function popWin(winProps, popComp, renderOpt) {
    var options = Object.assign({ title: '请选择' }, winProps)
    popComponent(popWinCtn, { props: options }, h => [
        h(popComp, renderOpt),
    ])
}

